import { render, staticRenderFns } from "./GymOrderRecord.vue?vue&type=template&id=76ad6d2b&"
import script from "./GymOrderRecord.vue?vue&type=script&lang=js&"
export * from "./GymOrderRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports